import React, { PropsWithChildren, ReactNode, useState } from 'react';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

interface Props {
  title: ReactNode;
  icon: ReactNode;
  isExpanded: boolean;
  isExpandable: boolean;
  actionSlot: ReactNode;
}

export const FormSection = ({
  icon,
  title,
  children,
  actionSlot,
  isExpanded = true,
  isExpandable = false,
}: PropsWithChildren<Partial<Props>>) => {
  const [isSectionExpanded, setIsSectionExpanded] = useState<boolean>(isExpanded);

  return (
    <Box>
      <Box
        sx={{
          gap: 1,
          width: '100%',
          display: 'flex',
          padding: '8px 12px',
          alignItems: 'center',
          backgroundColor: '#eeeeee',
        }}
      >
        {icon && icon}

        {title && (
          <Typography variant="subtitle2" component="span">
            {title}
          </Typography>
        )}

        {isExpandable && (
          <IconButton
            size="small"
            onClick={event => {
              event.stopPropagation();
              isExpandable && setIsSectionExpanded(!isSectionExpanded);
            }}
          >
            <ExpandMoreIcon
              sx={{
                fontSize: 22,
                transition: '0.5s',
                transform: isSectionExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
            />
          </IconButton>
        )}

        {actionSlot && actionSlot}
      </Box>

      <Collapse in={isSectionExpanded}>{children}</Collapse>
    </Box>
  );
};
